import { api } from "@/lib/api";

/** Convert base64url VAPID key to Uint8Array for PushManager.subscribe */
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return typeof window !== "undefined"
    && "serviceWorker" in navigator
    && "PushManager" in window
    && "Notification" in window;
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  return await navigator.serviceWorker.register("/service-worker.js");
}

export async function getExistingSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return await reg.pushManager.getSubscription();
}

export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Push not supported on this device");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error(`Notification permission ${perm}`);

  const { data } = await api.get("/push/config");
  if (!data.enabled || !data.public_key) throw new Error("Push not configured");

  await registerServiceWorker();
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await getExistingSubscription();
  if (!sub) return;
  const json = sub.toJSON();
  await sub.unsubscribe().catch(() => {});
  await api.post("/push/unsubscribe", { endpoint: json.endpoint, keys: json.keys });
}

export async function sendTestPush() {
  const r = await api.post("/push/test");
  return r.data;
}
